import { Box, Paper } from '@mui/material';
import { Wordmark } from './Brand';

// Shared frame for the sign-in / sign-up / password screens.
export default function AuthCard({ children }) {
  return (
    <Box sx={{
      minHeight: '100vh', bgcolor: 'background.default', p: 2,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3,
    }}>
      <Wordmark />
      <Paper sx={{ p: { xs: 2.5, sm: 3 }, width: '100%', maxWidth: 360, border: '1px solid', borderColor: 'divider' }}>
        {children}
      </Paper>
    </Box>
  );
}
